export default __webpack_public_path__ + "static/media/HYD-19.0bf01b7a.webp";